import React, { useState } from "react";
import { toast } from "sonner";
import api, { apiErrorMessage } from "../../lib/api";

/**
 * "Email alternativ pentru portal" — for somebody whose contract carries one
 * address and who reads another (the school's and their own). Set by the team
 * on request, never by the participant; every change goes to the audit log.
 */
export default function PortalEmailField({ enrollmentId, value }) {
  const [saved, setSaved] = useState(value || "");
  const [draft, setDraft] = useState(value || "");
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);

  const save = async (next) => {
    setBusy(true);
    try {
      const r = await api.put(`/admin/enrollments/${enrollmentId}/portal-email`, { email: next || null });
      setSaved(r.data.portal_email || "");
      setDraft(r.data.portal_email || "");
      setEditing(false);
      toast.success(r.data.portal_email ? "Adresa pentru portal e salvată." : "Portalul folosește adresa din contract.");
    } catch (err) {
      toast.error(apiErrorMessage(err, "Nu am putut salva adresa."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="enrollment-portal-email">
      <div className="text-[11px] uppercase tracking-wider text-[#6B7280] font-semibold">Email alternativ pentru portal</div>
      {editing ? (
        <div className="mt-1 flex flex-wrap items-center gap-2">
          <input type="email" value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="adresa@exemplu.ro"
            className="min-w-0 flex-1 rounded-lg border border-[#E5E7EB] px-2.5 py-1.5 text-sm focus:border-[#965EA7] focus:outline-none" />
          <button type="button" disabled={busy} onClick={() => save(draft.trim())}
            className="rounded-full bg-[#965EA7] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#7A4986]">Salvează</button>
          <button type="button" disabled={busy} onClick={() => { setEditing(false); setDraft(saved); }}
            className="text-xs font-semibold text-[#6B7280]">Renunță</button>
        </div>
      ) : (
        <div className="mt-0.5 flex flex-wrap items-center gap-2 text-sm text-[#373A45]">
          <span>{saved || <span className="text-[#9CA3AF]">— intră cu adresa din contract</span>}</span>
          <button type="button" onClick={() => setEditing(true)} className="text-xs font-semibold text-[#965EA7] hover:underline">
            {saved ? "Schimbă" : "Adaugă"}
          </button>
          {saved && (
            <button type="button" disabled={busy} onClick={() => save("")} className="text-xs font-semibold text-[#6B7280] hover:text-[#c0483f]">
              Șterge
            </button>
          )}
        </div>
      )}
    </div>
  );
}
